webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_db_json__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_db_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_db_json__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    db: __WEBPACK_IMPORTED_MODULE_2__utils_db_json___default.a
  },
  mutations: {
    disableFamily: function disableFamily(state, i) {
      state.db[i].enabled = false;
    },
    enableFamily: function enableFamily(state, i) {
      state.db[i].enabled = true;
    }
  },
  getters: {

    families: function families(state) {
      return state.db.map(function (item) {
        return item.family;
      });
    },

    categories: function categories(state) {
      return state.db.map(function (item) {
        return item.units;
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(27),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(4);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_grid_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_grid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Toolbar__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardBoard__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardBoard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CardBoard__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Toolbar: __WEBPACK_IMPORTED_MODULE_2__components_Toolbar___default.a,
    CardBoard: __WEBPACK_IMPORTED_MODULE_3__components_CardBoard___default.a
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card',
  props: ['img', 'species', 'about', 'wikiLink'],
  computed: {
    animalImage: function animalImage() {
      return 'static/' + this.img;
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_capitalize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Category__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Category___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Category__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'card-board',
  components: {
    Category: __WEBPACK_IMPORTED_MODULE_1__Category___default.a
  },
  methods: {
    capitalize: function capitalize(item) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize___default()(item);
    },
    showCategory: function showCategory(i) {
      return this.$store.state.db[i].family === this.$store.getters.families[i] && this.$store.state.db[i].enabled;
    },
    noAnimals: function noAnimals() {
      var arr = this.$store.state.db.filter(function (item) {
        return item.enabled;
      });
      return !arr[0];
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Card__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'category',
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_0__Card___default.a
  },
  props: ['title'],
  methods: {
    categIndex: function categIndex(title) {
      var families = this.$store.getters.families;
      return families.indexOf(title.toLowerCase().slice(0, -1));
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_capitalize__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toolbar',
  methods: {
    handleClick: function handleClick(event) {
      var store = this.$store;
      var text = event.target.innerText.toLowerCase().slice(0, -1);
      var i = store.getters.families.indexOf(text);
      if (text === store.state.db[i].family && store.state.db[i].enabled) {
        store.commit('disableFamily', i);
      } else {
        store.commit('enableFamily', i);
      }
    },
    buttonState: function buttonState(item, i) {
      var classes = [];
      var db = this.$store.state.db;

      if (item === db[i].family && db[i].enabled) {
        classes.push('button-family--enabled');
      } else {
        classes.push('button-family--disabled');
      }

      switch (item) {
        case 'penguin':
          classes.push('icon-penguin');
          break;
        case 'armadillo':
          classes.push('icon-armadillo');
          break;
        case 'mackerel':
          classes.push('icon-mackerel');
          break;
        default:
          classes.push('');
      }

      return classes;
    },
    capitalize: function capitalize(item) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_capitalize___default()(item);
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(23),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0974a3e1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(24),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ce652b5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(16)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(25),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c8e7a4f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(26),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8eb0988c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('article', {
    staticClass: "card"
  }, [_c('a', {
    staticClass: "card_image",
    attrs: {
      "href": _vm.wikiLink
    }
  }, [_c('img', {
    staticClass: "card__img",
    attrs: {
      "src": _vm.animalImage,
      "alt": _vm.species
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "card__species",
    attrs: {
      "href": _vm.wikiLink
    }
  }, [_vm._v(_vm._s(_vm.species))]), _vm._v(" "), _c('p', {
    staticClass: "card__about"
  }, [_vm._v(_vm._s(_vm.about))])])])
},staticRenderFns: []}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-board"
  }, [_vm._l((_vm.$store.getters.families), function(family, i) {
    return (_vm.showCategory(i)) ? _c('category', {
      key: ("" + family + i),
      attrs: {
        "title": _vm.capitalize(family) + 's'
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noAnimals()),
      expression: "noAnimals()"
    }],
    staticClass: "card-board__no-animals"
  }, [_vm._v("\n    There's no animals : (")])], 2)
},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "category__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _vm._l((_vm.$store.getters.categories[_vm.categIndex(_vm.title)]), function(animal, i) {
    return _c('div', {
      key: ("" + animal + i),
      staticClass: "col-12 col-md-6 col-lg-4"
    }, [_c('card', {
      attrs: {
        "img": animal.img,
        "species": animal.species,
        "about": animal.about,
        "wikiLink": animal.wikiLink
      }
    })], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar"
  }, _vm._l((_vm.$store.getters.families), function(item, i) {
    return _c('button', {
      key: ("" + item + i),
      staticClass: "button-family",
      class: _vm.buttonState(item, i),
      on: {
        "click": _vm.handleClick
      }
    }, [_vm._v("\n    " + _vm._s(_vm.capitalize(item) + 's') + "\n  ")])
  }))
},staticRenderFns: []}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('toolbar'), _vm._v(" "), _c('card-board')], 1)])
},staticRenderFns: []}

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = [
	{
		"family": "penguin",
		"enabled": true,
		"units": [
			{
				"species": "Aptenodytes forsteri",
				"img": "penguin1.jpg",
				"about": "The emperor penguin is the tallest and heaviest of all living penguin species and is endemic to Antarctica.",
				"wikiLink": "https://en.wikipedia.org/wiki/Emperor_penguin"
			}
		]
	},
	{
		"family": "armadillo",
		"enabled": true,
		"units": [
			{
				"species": "Dasypus novemcinctus",
				"img": "armadillo1.jpg",
				"about": "The nine-banded armadillo, or the nine-banded, long-nosed armadillo, is a medium-sized mammal found in North, Central, and South America, making it the most widespread of the armadillos.",
				"wikiLink": "https://en.wikipedia.org/wiki/Nine-banded_armadillo"
			},
			{
				"species": "Euphractus sexcinctus",
				"img": "armadillo2.jpg",
				"about": "The six-banded armadillo, also known as the yellow armadillo, is an armadillo found in South America. The sole member of its genus, it was first described by Swedish zoologist Carl Linnaeus in 1758.",
				"wikiLink": "https://en.wikipedia.org/wiki/Six-banded_armadillo"
			},
			{
				"species": "Zaedyus pichiy",
				"img": "armadillo3.jpg",
				"about": "The pichi or dwarf armadillo is a small armadillo native to Argentina and Chile. It is the only living member of the genus Zaedyus, and the only armadillo to hibernate.",
				"wikiLink": "https://en.wikipedia.org/wiki/Pichi"
			}
		]
	},
	{
		"family": "mackerel",
		"enabled": true,
		"units": [
			{
				"species": "Rastrelliger brachysoma",
				"img": "mackerel1.jpg",
				"about": "The short mackerel or shortbodied mackerel is a species of mackerel in the family Scombridae. Its habitat is the shallow waters of Southeast Asia and Melanesia, feeding mainly on small zooplankton.",
				"wikiLink": "https://en.wikipedia.org/wiki/Short_mackerel"
			},
			{
				"species": "Rastrelliger kanagurta",
				"img": "mackerel2.jpg",
				"about": "The Indian mackerel is a species of mackerel in the scombrid family (family Scombridae) of order Perciformes. It is commonly found in the Indian and West Pacific oceans, and their surrounding seas.",
				"wikiLink": "https://en.wikipedia.org/wiki/Indian_mackerel"
			},
			{
				"species": "Scomber colias",
				"img": "mackerel3.jpg",
				"about": "Atlantic chub mackerel is a pelagic schooling species of mackerel found in the Atlantic Ocean, the Mediterranean Sea, and the Black Sea.",
				"wikiLink": "https://en.wikipedia.org/wiki/Atlantic_chub_mackerel"
			},
			{
				"species": "Scomber japonicus",
				"img": "mackerel4.jpg",
				"about": "The chub mackerel, Pacific mackerel, or Pacific chub mackerel is a mackerel which closely resembles the Atlantic chub mackerel.",
				"wikiLink": "https://en.wikipedia.org/wiki/Chub_mackerel"
			},
			{
				"species": "Scomber scombrus",
				"img": "mackerel5.jpg",
				"about": "The Atlantic mackerel, also known as Boston mackerel, Norwegian mackerel, Scottish mackerel or just mackerel. The fish's dorsum is steel-blue and marked with wavy black lines, while the belly is silvery-white.",
				"wikiLink": "https://en.wikipedia.org/wiki/Atlantic_mackerel"
			}
		]
	}
];

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.44165f23e163a58b1fe5.js